// @noflow
import './primary-btn.component.css';

import { Button } from '../';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
/*
	Primary Btn Component
	@param {string || component} [children='save'] - content to be displayed within the button.
	@param {string} [className] - space delimited css classes to be added for styling.
	@param {bool} [processing] - determines whether or not to show processing animation.
	@param {string} [processingPhrase] - text to be displayed when displaying processing animation.
 */

PrimaryBtn.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    processing: PropTypes.bool,
    processingPhrase: PropTypes.string
};

PrimaryBtn.defaultProps = {
    children: 'Save'
};

export default function PrimaryBtn({ children, className, processing, processingPhrase, ...props }) {
    const buttonClasses = classnames(
        'primary-btn',
        {
            'primary-btn--processing': processing
        },
        className
    );
    return (
        <Button {...props} className={buttonClasses}>
            <span
                className={classnames('primary-btn__text-top', {
                    'primary-btn__text-top--hide': processing
                })}
            >
                {children}
            </span>
            <span
                className={classnames('primary-btn__text-bottom', {
                    'primary-btn__text-bottom--hide': processing
                })}
            >
                {children}
            </span>
            <p
                className={classnames('primary-btn__dots', {
                    'primary-btn__dots--show': processing
                })}
            >
                <span>{processingPhrase || children}</span>
                <span className="primary-btn__dot-1"> . </span>
                <span className="primary-btn__dot-2">. </span>
                <span className="primary-btn__dot-3">.</span>
            </p>
        </Button>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/primary-btn/primary-btn.component.js